(ns common.schema.entities.counterparty-diligence.templates.registry
  (:require
   [common.schema.entities.counterparty-diligence.templates.capman.legal-entity :as capman-legal-entity]
   [common.schema.entities.counterparty-diligence.templates.capman.natural-person :as capman-natural-person]
   [common.schema.entities.counterparty-diligence.templates.capman.project :as capman-project]
   [common.schema.entities.counterparty-diligence.templates.demo.legal-entity :as demo-legal-entity]
   [common.schema.entities.counterparty-diligence.templates.demo.natural-person :as demo-natural-person]
   [common.schema.entities.counterparty-diligence.templates.demo.project :as demo-project]
   [clojure.string :as string]))

(def templates
  {capman-legal-entity/template-id   capman-legal-entity/schema
   capman-project/template-id        capman-project/schema
   capman-natural-person/template-id capman-natural-person/schema
   demo-legal-entity/template-id     demo-legal-entity/schema
   demo-project/template-id          demo-project/schema
   demo-natural-person/template-id   demo-natural-person/schema})

(def legal-entity-templates
  {capman-legal-entity/template-id capman-legal-entity/schema
   demo-legal-entity/template-id   demo-legal-entity/schema})

(def natural-person-templates
  {capman-natural-person/template-id capman-natural-person/schema
   demo-natural-person/template-id   demo-natural-person/schema})

(def project-templates
  {capman-project/template-id capman-project/schema
   :counterparty-diligence-template/reindeer-project {:template/template-name "Reindeer project"}
   demo-project/template-id   demo-project/schema})

(def project-template-keys
  #{capman-project/template-id
    demo-project/template-id})

(def legal-entity-template-keys
  #{capman-legal-entity/template-id
    demo-legal-entity/template-id})

(def natural-person-template-keys
  #{capman-natural-person/template-id
    demo-natural-person/template-id})

(defn capman-template?
  [template-id]
  (when (keyword? template-id)
    (string/starts-with? (name template-id) "capman")))

(defn demo-template?
  [template-id]
  (when (keyword? template-id)
    (string/starts-with? (name template-id) "demo")))

(defn get-template
  [template-kw]
  (get templates template-kw))

(defn resolve-template-id
  [counterparty-diligence]
  (or (:company-counterparty-diligence/template counterparty-diligence)
      (:person-counterparty-diligence/template counterparty-diligence)
      (:project-counterparty-diligence/template counterparty-diligence)))

(defn resolve-template
  [counterparty-diligence]
  (let [template-id (resolve-template-id counterparty-diligence)]
    (get templates template-id)))

(defn template-belongs-to-tenant?
  [tenant template-id]
  (cond
    (-> tenant
        :tenant/name
        (= "CapMan"))
    (capman-template? template-id)

    :else
    (demo-template? template-id)))
